import { httpsCallable } from '@firebase/functions';
import { functions } from './firebase';
import type { UserRole } from '../types';

// Mirrors functions/src/invites/sendAudienceInvite.ts, the same way
// defensePlanUpdates.ts mirrors the plan-update callables. The gate,
// the caps and the suppression all live server side; this file only
// carries the shapes.

export interface SendAudienceInviteResult {
  sent: number;
  suppressed: number;
  failed: number;
}

export interface SendAudienceInviteInput {
  audience: UserRole;
  emails: string[];
  note?: string;
  areaName?: string;
}

/**
 * Email an audience intro link to people who are not in REDI yet.
 *
 * Moderator only, capped at 25 addresses a call and 5 calls a day. A
 * rejection arrives as a FirebaseError whose message is written to be shown
 * as-is: 'functions/permission-denied' for a non-moderator,
 * 'functions/invalid-argument' for a bad address or an over-long list,
 * 'functions/resource-exhausted' for the daily limit.
 */
export async function sendAudienceInvite(
  input: SendAudienceInviteInput
): Promise<SendAudienceInviteResult> {
  const callable = httpsCallable<SendAudienceInviteInput, SendAudienceInviteResult>(
    functions,
    'sendAudienceInvite'
  );
  const result = await callable(input);
  return result.data;
}
